<template>
  <div class="form-input" :class="{ 'form-input_error': error, 'form-input_focused': focused }">
    <label v-if="label" :for="inputId" class="form-input__label">{{ label }}</label>
    <component
      :is="tag"
      :id="inputId"
      :name="name"
      :type="type"
      :value="modelValue"
      :placeholder="placeholder"
      :required="required"
      :disabled="disabled"
      :rows="multiline ? (rows || 4) : undefined"
      class="form-input__field"
      :class="fieldClass"
      @input="onInput"
      @focus="focused = true"
      @blur="focused = false"
    />
    <span v-if="error" class="form-input__error">{{ error }}</span>
  </div>
</template>

<script>
import { ref, computed } from 'vue'

export default {
  name: 'FormInput',
  props: {
    modelValue: { type: [String, Number], default: '' },
    name: { type: String, default: '' },
    type: { type: String, default: 'text' },
    label: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    required: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    error: { type: String, default: '' },
    multiline: { type: Boolean, default: false },
    rows: { type: Number, default: 0 }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const focused = ref(false)
    const idCounter = Math.random().toString(36).slice(2, 9)
    const inputId = computed(() => props.name ? `form-input-${props.name}` : `form-input-${idCounter}`)
    const tag = computed(() => props.multiline ? 'textarea' : 'input')
    const fieldClass = computed(() => ({ 'form-input__field_textarea': props.multiline }))

    function onInput(e) {
      emit('update:modelValue', e.target.value)
    }

    return { focused, inputId, tag, fieldClass, onInput }
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/_variables.scss";

.form-input {
  width: 100%;
  margin-bottom: 0;

  &__label {
    display: block;
    font-size: 13px;
    font-weight: 600;
    color: $color-text-muted;
    margin-bottom: 8px;
  }

  &__field {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    padding: 12px 16px;
    font-size: 15px;
    font-family: inherit;
    color: $color-text;
    background: $color-primary-inverse;
    border: 1px solid $color-border;
    border-radius: 8px;
    transition: border-color 0.2s, box-shadow 0.2s;

    &::placeholder {
      color: rgba(0, 0, 0, 0.35);
    }
    &:focus {
      outline: none;
      border-color: $color-accent-teal;
      box-shadow: 0 0 0 3px rgba(13, 148, 136, 0.15);
    }

    &_textarea {
      min-height: 100px;
      resize: vertical;
    }
  }

  &_error .form-input__field {
    border-color: #c53030;
  }

  &__error {
    display: block;
    font-size: 12px;
    color: #c53030;
    margin-top: 6px;
  }
}
</style>
